module.exports = {
	"ga": ""
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/config.json
 ** module id = 168
 ** module chunks = 0
 **/